/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=4179020d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4179020d&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/link/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4179020d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4179020d', __exports__)) {
    console.log('reload')
    api.reload('4179020d', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4179020d", () => {
    console.log('re-render')
    api.rerender('4179020d', render)
  })

}


export default __exports__